export const BULK_MODE_MANUALLY = 'manually';
export const BULK_MODE_CONTRACTS = 'contracts';
export const BULK_MODE_ALL = 'all';
export const BULK_NOT_PROCESSED = 'not_processed';
export const BULK_ASSIGNED = 'assigned';
